import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer, ScreenNotificationDefault, InputText} from '../../components';
import {
  redirectToDocumentVerse,
  redirectToSignature,
  redirectToValidationAccessCode,
  redirectToHireInsurance,
  redirectToAdditionalCard,
} from '../../ducks/Navigate';
import {
  updateCartaoCredito,
  adicionarCartao,
  consultarSegurosDisponiveis,
  processaSituacaoPortadorFinalizada,
  processarAutorizacao,
} from '../../ducks/Customer';
import {
  ValidationService,
  AutoCapturaService,
  StringService,
  NotificationService,
} from '../../services';
import {RouteKeys} from '../../constants';
import validation from './validation';

import './styles.scss';

class YourCard extends Component {
  formIsValid = () =>
    ValidationService.validate({...this.props.cartao}, validation);

  state = {
    diasDeVencimento: null,
    tempoDaMensagem: 5000,
    numeroTentativas: 0,
    numeroTentativasMaximas: 2,
    notification: null,
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.YourCard.title);

    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      // EXIBE O NOME E O ULTIMO SOBRENOME
      if (
        !this.props.cartao.embossing &&
        this.props.dadosPessoais &&
        this.props.dadosPessoais.nome != null
      ) {
        const res = this.props.dadosPessoais.nome.split(' ');
        if (res.length > 0) {
          var nome = res[0];
          if (res.length > 1) {
            nome += ' ' + res[res.length - 1];
          }

          if (nome.length < 19) this.handleChange('embossing', nome);
          else {
            this.handleChange('embossing', nome.substr(0, 19));
          }
        }
      }
      const diasDeVencimento = await AutoCapturaService.getDiaDeVencimento();

      this.setState({diasDeVencimento: diasDeVencimento});
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    NotificationService.showConfirmWithTitle(
      'IMPORTANTE!',
      'Deseja incluir cartões adicionais gratuitos?',
      'Sim',
      'Não',
    ).then(async (result) => {
      if (result.value && result.value === true) {
        if (!this.formIsValid()) return;

        this.iniciarConsultaSegurosDisponiveis();

        setTimeout(async () => {
          let chave = this.props.chave;
          const dados = {
            chave,
            ...this.props.cartao,
          };
          await this.props.adicionarCartao(dados);
          this.finalizarConsultaSegurosDisponiveis();
          this.props.redirectToAdditionalCard();
        }, this.state.tempoDaMensagem);
      } else {
        if (
          !(await this.props.processaSituacaoPortadorFinalizada(
            this.props.chave,
          ))
        ) {
          if (!this.formIsValid()) return;

          this.iniciarConsultaSegurosDisponiveis();

          setTimeout(async () => {
            let chave = this.props.chave;
            const dados = {
              chave,
              ...this.props.cartao,
            };
            await this.props.adicionarCartao(dados);
            await this.buscarSegurosRota();
          }, this.state.tempoDaMensagem);
        } else this.finalizarConsultaSegurosDisponiveis();
      }
    });
  };

  buscarSegurosRota = async () => {
    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      let chave = this.props.chave;
      let possuiSeguros = await this.props.consultarSegurosDisponiveis(chave);
      this.incrementaContador();
      await this.processaHandle(possuiSeguros);
    } else this.finalizarConsultaSegurosDisponiveis();
  };

  iniciarConsultaSegurosDisponiveis = () => {
    let notification = NotificationService.showMessageWithoutButton(
      'Aguarde um instante, estamos processando sua requisição.',
    );
    this.setState({notification});
  };

  finalizarConsultaSegurosDisponiveis = () => {
    if (this.state.notification != null) {
      try {
        this.state.notification.close();
      } catch {}
    }

    let numeroTentativas = 1;
    this.setState({numeroTentativas});
  };

  incrementaContador = () => {
    let {numeroTentativas} = this.state;
    numeroTentativas++;
    this.setState({numeroTentativas});

    console.log('Contador....', this.state.numeroTentativas, new Date());
  };

  processaHandle = async (possuiSeguros) => {
    // deu certo, finaliza o processo
    if (possuiSeguros.sucesso) {
      await this.handleSucessoConsultaSeguros(possuiSeguros);
      return;
    }

    // não deu certo, e retornou 422
    if (!possuiSeguros.sucesso && !possuiSeguros.reprocessar) {
      await this.handleSucessoConsultaSeguros([]);
      return;
    }

    let registrarDenovo = false;

    // não deu certo, mas é erro sistemico, precisa reprocessar
    if (!possuiSeguros.sucesso && possuiSeguros.reprocessar) {
      // ainda permite reprocessar ?
      if (this.state.numeroTentativas < this.state.numeroTentativasMaximas)
        registrarDenovo = true;
      else {
        // se não permitir vai mostrar mensagem e direcionar para a tela inicial
        this.finalizarConsultaSegurosDisponiveis();

        NotificationService.showValidationSingleError(
          'Ocorreu um erro inesperado, por gentileza acesse novamente o seu convite em alguns minutos.',
        ).then(() => {
          this.props.redirectToValidationAccessCode();
        });
      }

      if (registrarDenovo) {
        setTimeout(async () => {
          await this.buscarSegurosRota();
        }, 10000);
      }
    }
  };

  handleSucessoConsultaSeguros = async (possuiSeguros) => {
    this.finalizarConsultaSegurosDisponiveis();
    if (possuiSeguros.seguros && possuiSeguros.seguros.length >= 1) {
      this.props.redirectToHireInsurance();
    } else {
      let chave = this.props.chave;
      const dados = {
        chave,
        autorizacao: [],
      };
      const processarAutorizacaoResponse =
        await this.props.processarAutorizacao(dados);
      if (processarAutorizacaoResponse.sucesso) {
        this.props.redirectToSignature();
      } else {
        NotificationService.showValidationSingleError(
          'Ocorreu um erro inesperado, por gentileza acesse novamente o seu convite em alguns minutos.',
        ).then(() => {
          this.props.redirectToValidationAccessCode();
        });
      }
    }
  };

  handleChange = (prop, value) => {
    this.props.updateCartaoCredito({prop, value});
  };

  handleChangeEmbossing = (event) => {
    const prop = 'embossing';
    let value = event.target.value.slice(0, event.target.maxLength);
    value = this.filterName(value);

    this.props.updateCartaoCredito({prop, value});
  };

  filterName = (value) => {
    var valueTemp = StringService.clearString(value);
    return valueTemp.toUpperCase();
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Seu cartão</p>}
        contentCustom={
          <div className="div-your-card">
            <form className="form" id="frm" onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label className="form-label" style={{top: -20}}>
                  Escolha o melhor dia de vencimento para a sua fatura
                </label>
              </div>
              <div className="group-question">
                <div className="form-group option-question">
                  {this.state.diasDeVencimento &&
                    this.state.diasDeVencimento.map((dia, indice) => (
                      <div className="checkbox text-align" key={indice}>
                        <input
                          className="form-field"
                          type="radio"
                          id={'diaVencimento' + dia}
                          name="diaVencimento"
                          value={dia}
                          checked={
                            this.props.cartao.diaDeVencimento.toString() ===
                            dia.toString()
                              ? true
                              : false
                          }
                          onChange={(ev) =>
                            this.handleChange(
                              'diaDeVencimento',
                              ev.target.value,
                            )
                          }
                        />
                        <label htmlFor={'diaVencimento' + dia}>{dia}</label>
                      </div>
                    ))}
                </div>
              </div>
              <div className="info-vencimento">
                Caso prefira outra data, você poderá alterar o vencimento da
                fatura no momento do desbloqueio do seu cartão.
              </div>
              <div className="info-fatura">
                A fatura será enviada para seu e-mail.
              </div>
              <InputText
                type="text"
                id="embossing"
                maxLength="19"
                value={this.props.cartao.embossing.toUpperCase()}
                onChange={(ev) => this.handleChangeEmbossing(ev)}
                placeholder="Nome impresso no cartão"
              />

              <div className="form-group form-group-length-name">
                <div className="div-text">Máximo 19 caracteres</div>
                <div className="div-text">
                  {this.props.cartao.embossing.length}/19
                </div>
              </div>
            </form>
          </div>
        }
        contentButtons={
          <div className="footer-your-card">
            <Footer
              backHandle={() => {
                this.props.redirectToDocumentVerse();
              }}
              nextForm="frm"
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {chave, cartao, dadosPessoais} = customer;
  return {
    chave,
    cartao,
    dadosPessoais,
  };
};

export default connect(mapStateToProps, {
  redirectToDocumentVerse,
  adicionarCartao,
  updateCartaoCredito,
  redirectToSignature,
  consultarSegurosDisponiveis,
  redirectToValidationAccessCode,
  redirectToHireInsurance,
  processaSituacaoPortadorFinalizada,
  processarAutorizacao,
  redirectToAdditionalCard,
})(YourCard);
